import React from 'react';

import type { SvgProps } from '../enums';

export const FlagNU: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55176"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55176)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V12H16V0H0Z"
        fill="#2E42A5"
      />
      <mask
        id="mask1_270_55176"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_55176)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8V12H16V8H0Z"
          fill="#FECA00"
        />
        <mask
          id="mask2_270_55176"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="8"
        >
          <rect width="16" height="8" fill="white" />
        </mask>
        <g mask="url(#mask2_270_55176)">
          <path
            // eslint-disable-next-line max-len
            d="M-1.1311 7.56469L2.04026 8.29834L8.80079 4.56288L9.51617 4.14457L15.938 0.786738L17.4593 -0.273776L13.9795 -0.594706L8.36866 2.5703L4.31397 4.56288L-1.1311 7.56469Z"
            fill="white"
          />
          <path
            d="M-0.852478 8.00942L0.854994 8.56949L16.8245 -0.40702H14.427L-0.852478 8.00942Z"
            fill="#F50100"
          />
          <path
            // eslint-disable-next-line max-len
            d="M17.1854 7.36539L17.3113 8.1204L13.9597 8.29834L8.55665 5.13367L8.04722 5.30771L-2.04023 0.205323L2.12469 -0.596345L7.69267 2.47959L12.0484 4.58422L17.1854 7.36539Z"
            fill="white"
          />
          <path
            // eslint-disable-next-line max-len
            d="M17.1969 7.81853L15.4894 8.3786L8.68946 4.53529L6.67341 4.10589L-1.62947 -0.268852H0.768023L9.06624 4.00205L11.2704 4.51695L17.1969 7.81853Z"
            fill="#F50100"
          />
          <path
            // eslint-disable-next-line max-len
            d="M6.5945 -0.625V-1.25H5.9695V-0.625H6.5945ZM6.5945 2.375V3H7.2195V2.375H6.5945ZM-0.625 2.375V1.75H-1.25V2.375H-0.625ZM-0.625 5.625H-1.25V6.25H-0.625V5.625ZM6.5945 5.625H7.2195V5H6.5945V5.625ZM6.5945 9.625H5.9695V10.25H6.5945V9.625ZM9.43877 9.625V10.25H10.0638V9.625H9.43877ZM9.43877 5.625V5H8.81377V5.625H9.43877ZM16.625 5.625V6.25H17.25V5.625H16.625ZM16.625 2.375H17.25V1.75H16.625V2.375ZM9.43877 2.375H8.81377V3H9.43877V2.375ZM9.43877 -0.625H10.0638V-1.25H9.43877V-0.625ZM8.18877 2.375V3H8.81377V2.375H8.18877ZM8.18877 0.625H8.81377V0H8.18877V0.625ZM7.8445 0.625V0H7.2195V0.625H7.8445ZM7.8445 2.375H7.2195V3H7.8445V2.375ZM8.18877 3.625H8.81377V3H8.18877V3.625ZM7.8445 3.625V3H7.2195V3.625H7.8445ZM8.18877 4.375V5H8.81377V4.375H8.18877ZM7.8445 4.375H7.2195V5H7.8445V4.375ZM6.5945 3.625H7.2195V3H6.5945V3.625ZM0.625 3.625V3H0V3.625H0.625ZM0.625 4.375H0V5H0.625V4.375ZM6.5945 4.375V5H7.2195V4.375H6.5945ZM7.8445 5.625V5H7.2195V5.625H7.8445ZM7.8445 8.375H7.2195V9H7.8445V8.375ZM8.18877 8.375V9H8.81377V8.375H8.18877ZM8.18877 5.625H8.81377V5H8.18877V5.625ZM9.43877 3.625V3H8.81377V3.625H9.43877ZM9.43877 4.375H8.81377V5H9.43877V4.375ZM15.375 3.625H16V3H15.375V3.625ZM15.375 4.375V5H16V4.375H15.375ZM6.5945 0H7.2195V-1.25H6.5945V0ZM7.2195 0V-0.625H5.9695V0H7.2195ZM7.2195 2.375V0H5.9695V2.375H7.2195ZM0 3H6.5945V1.75H0V3ZM-0.625 3H0V1.75H-0.625V3ZM0 3V2.375H-1.25V3H0ZM0 5V3H-1.25V5H0ZM0 5.625V5H-1.25V5.625H0ZM0 5H-0.625V6.25H0V5ZM6.5945 5H0V6.25H6.5945V5ZM7.2195 9V5.625H5.9695V9H7.2195ZM7.2195 9.625V9H5.9695V9.625H7.2195ZM7.2195 9H6.5945V10.25H7.2195V9ZM8.81377 9H7.2195V10.25H8.81377V9ZM9.43877 9H8.81377V10.25H9.43877V9ZM8.81377 9V9.625H10.0638V9H8.81377ZM8.81377 5.625V9H10.0638V5.625H8.81377ZM16 5H9.43877V6.25H16V5ZM16.625 5H16V6.25H16.625V5ZM16 5V5.625H17.25V5H16ZM16 3V5H17.25V3H16ZM16 2.375V3H17.25V2.375H16ZM16 3H16.625V1.75H16V3ZM9.43877 3H16V1.75H9.43877V3ZM8.81377 0V2.375H10.0638V0H8.81377ZM8.81377 -0.625V0H10.0638V-0.625H8.81377ZM8.81377 0H9.43877V-1.25H8.81377V0ZM7.2195 0H8.81377V-1.25H7.2195V0ZM8.81377 2.375V0.625H7.56377V2.375H8.81377ZM8.18877 0H7.8445V1.25H8.18877V0ZM7.2195 0.625V2.375H8.4695V0.625H7.2195ZM7.8445 3H8.18877V1.75H7.8445V3ZM8.18877 3H7.8445V4.25H8.18877V3ZM8.81377 4.375V3.625H7.56377V4.375H8.81377ZM7.8445 5H8.18877V3.75H7.8445V5ZM7.2195 3.625V4.375H8.4695V3.625H7.2195ZM6.5945 3H0.625V4.25H6.5945V3ZM0 3.625V4.375H1.25V3.625H0ZM0.625 5H6.5945V3.75H0.625V5ZM7.2195 4.375V3.625H5.9695V4.375H7.2195ZM7.2195 5.625V8.375H8.4695V5.625H7.2195ZM7.8445 9H8.18877V7.75H7.8445V9ZM8.81377 8.375V5.625H7.56377V8.375H8.81377ZM8.18877 5H7.8445V6.25H8.18877V5ZM8.81377 3.625V4.375H10.0638V3.625H8.81377ZM15.375 3H9.43877V4.25H15.375V3ZM16 4.375V3.625H14.75V4.375H16ZM9.43877 5H15.375V3.75H9.43877V5Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.84615 -0.666656H7.15385V3.00001H0V5.00001H7.15385V9.66668H8.84615V5.00001H17V3.00001H8.84615V-0.666656Z"
            fill="#F50100"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M8.02502 5.29999C8.78442 5.29999 9.40002 4.68438 9.40002 3.92499C9.40002 3.1656 8.78442 2.54999 8.02502 2.54999C7.26563 2.54999 6.65002 3.1656 6.65002 3.92499C6.65002 4.68438 7.26563 5.29999 8.02502 5.29999Z"
          fill="#2E42A5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M8.05 4.34564L7.40106 4.79721L7.63 4.04049L7 3.56286L7.79043 3.54675L8.05 2.79999L8.30957 3.54675L9.1 3.56286L8.47 4.04049L8.69894 4.79721L8.05 4.34564Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M3.54999 4.28804L3.00921 4.66435L3.19999 4.03375L2.67499 3.63572L3.33368 3.6223L3.54999 3L3.7663 3.6223L4.42499 3.63572L3.89999 4.03375L4.09077 4.66435L3.54999 4.28804Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M12.55 4.28804L12.0092 4.66435L12.2 4.03375L11.675 3.63572L12.3337 3.6223L12.55 3L12.7663 3.6223L13.425 3.63572L12.9 4.03375L13.0908 4.66435L12.55 4.28804Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M8.04999 1.88805L7.50921 2.26436L7.69999 1.63376L7.17499 1.23573L7.83368 1.22231L8.04999 0.600006L8.2663 1.22231L8.92499 1.23573L8.39999 1.63376L8.59077 2.26436L8.04999 1.88805Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M8.04999 7.18807L7.50921 7.56437L7.69999 6.93378L7.17499 6.53575L7.83368 6.52233L8.04999 5.90002L8.2663 6.52233L8.92499 6.53575L8.39999 6.93378L8.59077 7.56437L8.04999 7.18807Z"
          fill="#FECA00"
        />
      </g>
    </g>
  </svg>
);
